import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

type Props = {
  style?: React.CSSProperties;
  className?: string;
};

function DefaultLoader({ style, className }: Props) {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "grid",
        placeItems: "center",
        ...style,
      }}
      className={className}
    >
      <CircularProgress aria-label="Loading" />
    </div>
  );
}

export default DefaultLoader;
